import * as React from 'react';
import styled from 'styled-components';
import { useState } from 'react';
import { useRef } from 'react';
import { useLayoutEffect } from 'react';
import { Grid } from '../Grid';
import { FlexRow } from '../FlexRow';
import { Button } from '../Button';
import { BodyText } from '../Typography';
import type { FCWithChildren } from '../../../types/FCWithChildren';

export enum SeeMoreLessSize {
  small = 90,
  regular = 180,
  large = 500,
}

interface ISeeMoreLessBlock {
  maxHeight: SeeMoreLessSize;
}

export const SeeMoreLessBlock: FCWithChildren<ISeeMoreLessBlock> = ({ children, maxHeight }) => {
  const targetRef = useRef<HTMLDivElement>(null);
  const height = targetRef && targetRef.current ? (targetRef.current as any).offsetHeight : 0;
  const [showSeeMoreButton, setShowSeeMoreButton] = useState(false);
  const [showSeeLessButton, setShowSeeLessButton] = useState(false);

  useLayoutEffect(() => {
    if (targetRef && targetRef.current) {
      setShowSeeMoreButton((targetRef.current as any).offsetHeight > maxHeight);
    }
  }, [maxHeight, targetRef, height]);

  const seeMore = () => {
    setShowSeeMoreButton(false);
    setShowSeeLessButton(true);
  };

  const seeLess = () => {
    setShowSeeMoreButton(true);
    setShowSeeLessButton(false);
  };

  return (
    <Grid>
      <SeeMoreLess showSeeMore={showSeeMoreButton} maxHeight={maxHeight}>
        <div ref={targetRef}>{children}</div>
      </SeeMoreLess>
      <FlexRow>
        {showSeeMoreButton ? (
          <Button intent={'ghost'} isInline onClick={seeMore}>
            See More
          </Button>
        ) : null}
        {showSeeLessButton ? (
          <Button intent={'ghost'} isInline onClick={seeLess}>
            See Less
          </Button>
        ) : null}
      </FlexRow>
    </Grid>
  );
};

export const SeeMoreLess = styled(BodyText)<{ showSeeMore: boolean; maxHeight: SeeMoreLessSize }>`
  white-space: pre-line;
  position: relative;
  box-sizing: content-box;
  ${(props) =>
    props.showSeeMore
      ? `
    max-height: ${props.maxHeight}px;
    overflow: hidden;
    &::after {
      width: 100%;
      height: 0;
      position: absolute;
      bottom: 0;
      left: 0;
      box-shadow: 0 0 50px 30px ${props.theme.colors.defaultContentBackground};
      content: ' ';
    }`
      : null}
`;
